import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMatrice = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 9" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-9",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "icon_Background",
				x: 0,
				y: 0,
				width: 1e3,
				height: 1e3
			}), /* @__PURE__ */ _jsxs("g", {
				id: "matrice-complessa",
				transform: "translate(172.666667, 156.888889)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-Copy-8",
						stroke: "#0056C1",
						strokeWidth: 28,
						x: 146.888889,
						y: 39.0555556,
						width: 110.888889,
						height: 194.222222
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-Copy-9",
						stroke: "#0056C1",
						strokeWidth: 28,
						x: 396.888889,
						y: 39.0555556,
						width: 110.888889,
						height: 194.222222
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-Copy-10",
						stroke: "#0056C1",
						strokeWidth: 28,
						x: 396.888889,
						y: 427.944444,
						width: 110.888889,
						height: 194.222222
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-Copy-11",
						stroke: "#0056C1",
						strokeWidth: 28,
						x: 146.888889,
						y: 427.944444,
						width: 110.888889,
						height: 194.222222
					}),
					/* @__PURE__ */ _jsx("polygon", {
						id: "|",
						fill: "#424548",
						fillRule: "nonzero",
						points: "36.3771344 667.555556 36.3771344 0.888888889 -4.54747351e-13 0.888888889 -4.54747351e-13 667.555556"
					}),
					/* @__PURE__ */ _jsx("polygon", {
						id: "|",
						fill: "#424548",
						fillRule: "nonzero",
						points: "647.488245 667.555556 647.488245 0.888888889 611.111111 0.888888889 611.111111 667.555556"
					}),
					/* @__PURE__ */ _jsx("polygon", {
						id: "Rectangle-Copy-14",
						fill: "#0056C1",
						points: "771.777778 676.444444 771.777778 787.555556 660.666667 787.555556"
					})
				]
			})]
		})
	})]
});
export default SvgMatrice;
